/* eslint-disable no-console */

class RecordingManager {
  constructor() {
    this.activeRecordingId = null
    this.transcribingInstanceId = null
    this.recordingInstances = new Map()
    this.listeners = new Set()
  }

  // Register a VoiceInput instance
  registerInstance(id, stopRecordingCallback) {
    this.recordingInstances.set(id, stopRecordingCallback)
    console.log(`🎤 RecordingManager: Registered instance ${id}`)
  }

  // Unregister a VoiceInput instance
  unregisterInstance(id) {
    this.recordingInstances.delete(id)
    if (this.activeRecordingId === id) {
      this.activeRecordingId = null
    }
    if (this.transcribingInstanceId === id) {
      this.transcribingInstanceId = null
    }
    console.log(`🎤 RecordingManager: Unregistered instance ${id}`)
  }

  // Set transcription state for an instance
  setTranscribing(id, isTranscribing) {
    if (isTranscribing) {
      this.transcribingInstanceId = id
      console.log(`🎤 RecordingManager: Instance ${id} started transcribing`)
    } else if (this.transcribingInstanceId === id) {
      this.transcribingInstanceId = null
      console.log(`🎤 RecordingManager: Instance ${id} finished transcribing`)
    }
    this.notifyListeners(id, isTranscribing ? "transcribing" : "completed")
  }

  // Request to start recording
  requestStartRecording(id) {
    if (this.activeRecordingId && this.activeRecordingId !== id) {
      console.log(`🎤 RecordingManager: Stopping active recording ${this.activeRecordingId} for new request from ${id}`)

      // Stop the currently active recording
      const activeCallback = this.recordingInstances.get(this.activeRecordingId)
      if (activeCallback) {
        activeCallback()
      }
    }

    this.activeRecordingId = id
    this.notifyListeners(id, true)
    console.log(`🎤 RecordingManager: Recording started for instance ${id}`)
    return true
  }

  // Notify that recording has stopped
  recordingStopped(id) {
    if (this.activeRecordingId === id) {
      this.activeRecordingId = null
      this.notifyListeners(id, false)
      console.log(`🎤 RecordingManager: Recording stopped for instance ${id}`)
    }
  }

  // Check if any instance is currently recording
  isAnyRecording() {
    return this.activeRecordingId !== null
  }

  // Check if any instance is currently transcribing
  isAnyTranscribing() {
    return this.transcribingInstanceId !== null
  }

  // Check if a specific instance should be disabled (another instance is recording or transcribing)
  shouldDisableInstance(id) {
    const isRecording = this.activeRecordingId !== null && this.activeRecordingId !== id
    const isTranscribing = this.transcribingInstanceId !== null && this.transcribingInstanceId !== id
    return isRecording || isTranscribing
  }

  // Get the currently active recording instance ID
  getActiveRecordingId() {
    return this.activeRecordingId
  }

  // Get the currently transcribing instance ID
  getTranscribingInstanceId() {
    return this.transcribingInstanceId
  }

  // Add a listener for recording state changes
  addListener(callback) {
    this.listeners.add(callback)
  }

  // Remove a listener
  removeListener(callback) {
    this.listeners.delete(callback)
  }

  // Notify all listeners of recording state changes
  notifyListeners(recordingId, isRecording) {
    this.listeners.forEach((callback) => {
      try {
        callback(recordingId, isRecording)
      } catch (error) {
        console.error("RecordingManager: Error in listener callback:", error)
      }
    })
  }
}

// Create a singleton instance
const recordingManager = new RecordingManager()

export default recordingManager
